import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  height: 100%;
  border-collapse: collapse;
  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.07),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.11);
  position: relative;
  margin-bottom: 2rem;
`;
